"use strict";

import { Model } from "../model";
import { Objects } from "Constants/objects";
export var FormFilterFieldsModel = Model.extend({
  initialize: function initialize() {
    this.object = Objects.SysFormFilterFields;
  }
});